import {
  put, select, all
} from 'redux-saga/effects';
import axios from '../../axios-local-api';
import * as actions from '../actions';
import packageJson from '../../../package.json';
import { EquipmentTypes } from '../../shared/common';


export function* initEquipmentSaga(action) {
  // console.log('init equip', action)
  // console.log('GETTING EQUIPPPPPPS')
  const accountNumber = yield sessionStorage.getItem('accountNumber');
  const divID = yield sessionStorage.getItem('divID');
  const rMac = yield sessionStorage.getItem('mac');
  yield put(actions.initEquipmentStart());
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
    try {
      let response = {};

      response = yield axios.post(
        '/equipment',
        {
          accountNumber: accountNumber,
          divID: divID,
          bToken: token,
          sessionToken: sessionToken,
          rMac: rMac
        }
      )

      if (response.data.equipment) {
        if (action.selectedEquipment) {
          // console.log(action.selectedEquipment, "action.selectedEquipment props")
          yield put(actions.setSelectedEquipment(action.selectedEquipment));
        } else {
          yield put(actions.setSelectedEquipment({
            displayAllEquipment: true,
            type: EquipmentTypes.Equipment
          }))

        }
         yield put(actions.setEquipment(response.data.equipment));


      } else {
        // console.log('Could not get Equipment at this time')
        // yield put(actions.fetchEquipmentFailed());
      }

      // yield put(actions.fetchEquipmentSuccess());
    } catch (error) {
      console.error('THERE WAS ERR', error)
      // yield put(actions.fetchEquipmentFailed());
    }
  } else {
    // console.log('NO TOKEN')

  }
}

export function* initSelectedEquipmentSaga(action) {
  // console.log('init SELECTED equip')

  if (action.selectedEquipment) {
    yield put(actions.setSelectedEquipment(action.selectedEquipment));
  } else {

    yield put(actions.setSelectedEquipment({
      displayAllEquipment: true,
      type: EquipmentTypes.Equipment
    }))
  }
}

export function* rebootPodSaga(action) {
  // console.log('REBOOT EQUP')

  // console.log('ACTIONDDD', action)
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const accountNumber = yield sessionStorage.getItem('accountNumber');
  const eventName = 'Reboot-Initiate';
  const eventType = 'Troubleshooting - Extender Reboot Initiate';
  const divId = yield sessionStorage.getItem('divId');
  const user = yield sessionStorage.getItem('userId');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  const pSerial = action.pSerial;
  if (sessionToken) {
    try {
      let response = {};

      response = yield axios.post(
        '/rebootPod',
        {
          rMac: rMac || '',
          bToken: token,
          accountNumber: accountNumber,
          eventName: eventName,
          eventType: eventType,
          divId: divId,
          user: user,
          sessionToken: sessionToken,
          pSerial: pSerial
        }
      )
      if (response.data.status === 200) {
        // console.log('GOT REBOOT POD SUCCESS')
        yield put(actions.initEquipment())
        yield put(actions.changePodSuccess());
        yield put(actions.podRestarting(pSerial));
        var timerStart = new Date();
        yield put(actions.checkWan(rMac, token, sessionToken, packageJson.firstCheckWanWait, timerStart));
      } else {
        // console.log('THERES A POD REBOOT ERROR')
        yield put(actions.changePodFailed());
      }

    } catch (error) {
      // console.error('THERES A POD REBOOT ERROR', error)
      yield put(actions.changePodFailed());
    }
  } else {
    // console.log('NO TOKEN')
    yield put(actions.changePodFailed());

  }


}
export function* claimPodSaga(action) {

  // console.log('claimPodSaga', claimPodSaga);
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const accountNumber = yield sessionStorage.getItem('accountNumber');
  // const eventName = 'Reboot-Initiate';
  // const eventType = 'Troubleshooting - Pod Reboot Initiate';
  const divId = yield sessionStorage.getItem('divId');
  const user = yield sessionStorage.getItem('userId');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  const pSerial = action.pSerial;
  const macAddress = action.macAddress;
  if (sessionToken) {
    try {
      let response = {};

      response = yield axios.post(
        '/claimPod',
        {
          rMac: rMac || '',
          bToken: token,
          accountNumber: accountNumber,
          // eventName: eventName,
          // eventType: eventType,
          divId: divId,
          user: user,
          sessionToken: sessionToken,
          pSerial: pSerial,
          macAddress: macAddress
        }
      )
      if (response.data.status === 200) {
        // console.log('GETTING SUCCESS FOR CLAIM POD')
        yield put(actions.initEquipment())
        yield put(actions.changePodSuccess());

        // yield put(actions.restarting());
        var timerStart = new Date();
      } else {
        // console.log('THERES A POD CLAIM ERROR')
        yield put(actions.changePodFailed());
      }

    } catch (error) {
      // console.error('THERES A POD CLAIM ERROR', error)
      yield put(actions.changePodFailed());
    }
  } else {
    // console.log('NO TOKEN')
    yield put(actions.changePodFailed());

  }


}


export function* reclaimPodSaga(action) {
  // console.log('reclaim pod')

  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const accountNumber = yield sessionStorage.getItem('accountNumber');
  // const eventName = 'Reboot-Initiate';
  // const eventType = 'Troubleshooting - Pod Reboot Initiate';
  const divId = yield sessionStorage.getItem('divId');
  const user = yield sessionStorage.getItem('userId');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  const pSerial = action.pSerial;
  if (sessionToken) {
    try {
      let response = {};


      response = yield axios.post(
        '/reclaimPod',
        {
          rMac: rMac || '',
          bToken: token,
          accountNumber: accountNumber,
          // eventName: eventName,
          // eventType: eventType,
          divId: divId,
          user: user,
          sessionToken: sessionToken,
          pSerial: pSerial
        }
      )
      if (response.data.status === 200) {
        yield put(actions.initEquipment())
        yield put(actions.changePodSuccess());
        // yield put(actions.restarting());
        var timerStart = new Date();
      } else {
        // console.log('THERES A POD RECLAIM ERROR')
        yield put(actions.changePodFailed());
      }

    } catch (error) {
      // console.error('THERES A POD RECLAIM ERROR', error)
      yield put(actions.changePodFailed());
    }
  } else {
    // console.log('NO TOKEN')
    yield put(actions.changePodFailed());

  }


}
export function* changePodSaga(action) {
  // console.log('CHANGE POD SAGA')
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const accountNumber = yield sessionStorage.getItem('accountNumber');
  // const eventName = 'Reboot-Initiate';
  // const eventType = 'Troubleshooting - Pod Reboot Initiate';
  const divId = yield sessionStorage.getItem('divId');
  const user = yield sessionStorage.getItem('userId');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  const pSerial = action.pSerial;
  const nickName = action.nickName;
  if (sessionToken) {
    try {
      let response = {};

      response = yield axios.post(
        '/changePod',
        {
          rMac: rMac || '',
          bToken: token,
          accountNumber: accountNumber,
          // eventName: eventName,
          // eventType: eventType,
          divId: divId,
          user: user,
          sessionToken: sessionToken,
          pSerial: pSerial,
          nickName: nickName
        }
      )
      if (response.data.status === 200) {
        // yield put(actions.initEquipment())
        yield put(actions.changePodSuccess(nickName));
        yield put(actions.updateEquipmentPodName({ pSerial, nickName }));
        // yield put(actions.restarting());

      } else {
        // console.log('THERES A POD CHANGE ERROR', response.data)
        yield put(actions.changePodFailed());
      }

    } catch (error) {
      // console.error('THERES A POD CHANGE ERROR', error)
      yield put(actions.changePodFailed());
    }
  } else {
    // console.log('NO TOKEN')
    yield put(actions.changePodFailed());

  }


}


export function* changeEquipmentName(action) {
  // console.log('change wquip')

  yield put(actions.initEquipmentStart());
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const accountNumber = yield sessionStorage.getItem('accountNumber');
  const eventName = 'SSID/Password';
  const eventType = 'Default Network - SSID Updated';
  const divId = yield sessionStorage.getItem('divId');
  const user = yield sessionStorage.getItem('userId');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {

    try {
      const response = yield axios.post(
        '/settingsWifiNamePass',
        {
          rMac: rMac || '',
          bToken: token,
          name: action.payload.name,
          accountNumber: accountNumber,
          eventName: eventName,
          eventType: eventType,
          divId: divId,
          user: user,
          sessionToken: sessionToken
        }

      );
      if (response.data.status === 200) {
        yield put(actions.changeEquipmentNameSucces());
      } else {
        // console.log('THERES CHANGE NAME OR PASSWORD ERROR')
        yield put(actions.changeEquipmentNameFailed());
      }

    } catch (error) {
      // console.error('THERES CHANGE PASSWORD ERROR', error)
      yield put(actions.changeEquipmentNameFailed());
    }
  } else {
    // console.log('NO TOKEN')
    yield put(actions.changeEquipmentNameFailed());

  }


}

export function* setLocatePodSaga(action) {
  // console.log('LOCATE POD SAGA')
  // console.log('LOCATE POD SAGA ACTION', action)
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  const pSerial = action.locatePod.pSerial;
  const mode = (action.locatePod.mode === true) ? 'locate' : 'normal';
  if (sessionToken) {
    try {
      let response = {};
      yield put(actions.updateLocatePod(action.locatePod.mode));
      response = yield axios.post(
        '/podLocate',
        {
          rMac: rMac || '',
          bToken: token,
          sessionToken: sessionToken,
          pSerial: pSerial,
          mode: mode
        }
      )
      if (response.data.status === 200) {
        yield put(actions.locatePodSuccess());

      } else {
        // console.log('THERES A LOCATE POD ERROR', response.data)
        yield put(actions.locatePodFailed());
      }

    } catch (error) {
      // console.error('THERES A LOCATE POD ERROR', error)
      yield put(actions.locatePodFailed());
    }
  } else {
    // console.log('NO TOKEN')
    yield put(actions.changePodFailed());

  }


}
export function* locateAllPodsSaga(action, getState) {
  // console.log('LOCATE ALL PODS SAGA', action)
  // console.log('LOATW')
  const getPods = (state) => state.equipment.realEquipment.claimedPods
  const pods = yield select(getPods)
  for (var pod of pods) {
    const payload = {
      pSerial: pod.serialNumber,
      mode: false
    };
    // console.log('DO SET LOCATE POD', payload.pSerial)
    yield put(actions.setLocatePod(payload))
  }



}


